"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardDto = void 0;
const canDto_1 = require("./canDto");
const folderDto_1 = require("./folderDto");
const reportDto_1 = require("./reportDto");
class DashboardDto extends reportDto_1.ReportDto {
    constructor(dashboardDto, lastViewedAt) {
        super(dashboardDto.id, dashboardDto.title, dashboardDto.description, new folderDto_1.FolderDto(dashboardDto.folder), new canDto_1.CanDto(dashboardDto.can), dashboardDto.content_metadata_id, dashboardDto.content_favorite_id, dashboardDto.user_id, dashboardDto.created_at, dashboardDto.deleted_at, dashboardDto.favorite_count, dashboardDto.viewCount, lastViewedAt);
        this.preferredViewer = dashboardDto.preferredViewer;
    }
    static get QUERY_FIELDS() {
        return `${reportDto_1.ReportDto.QUERY_FIELDS},preferred_viewer`;
    }
}
exports.DashboardDto = DashboardDto;
